import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import { Constants as CONSTANTS } from "./constants.class";
import Layer from "@mozaic-ds/freemarker/js/modules/_layer";
var FiltersLayer = /*#__PURE__*/function () {
  function FiltersLayer() {
    _classCallCheck(this, FiltersLayer);
    this.layer = null;
    this.initLayer();
  }
  return _createClass(FiltersLayer, [{
    key: "initLayer",
    value: function initLayer() {
      this.layer = new Layer({
        classContent: CONSTANTS.FILTERS_LAYER.CONTENT,
        isScrollEdge: false
      });
      this.initOpenLayerEvent();
      this.initCloseLayerEvent();
      this.updateLayerAccessibility();
    }
  }, {
    key: "initOpenLayerEvent",
    value: function initOpenLayerEvent() {
      var _this = this;
      var openLayerButton = document.querySelector(".".concat(CONSTANTS.FILTERS_LAYER.OPEN_BUTTON));
      openLayerButton.addEventListener("click", function () {
        return _this.layer.open();
      });
    }
  }, {
    key: "initCloseLayerEvent",
    value: function initCloseLayerEvent() {
      var _this2 = this;
      var closeLayerButton = document.querySelector(".".concat(CONSTANTS.FILTERS_LAYER.CLOSE_BUTTON));
      closeLayerButton.addEventListener("click", function () {
        return _this2.layer.close();
      });
    }
  }, {
    key: "updateLayerAccessibility",
    value: function updateLayerAccessibility() {
      var openLayerButton = document.querySelector(".".concat(CONSTANTS.FILTERS_LAYER.OPEN_BUTTON));
      if (!openLayerButton.offsetParent) {
        // If there isn't offsetParent, it means the button is not displayed, so filters are displayed on desk
        var layer = document.querySelector(".".concat(CONSTANTS.FILTERS_LAYER.CONTENT));
        layer.setAttribute("aria-hidden", "false");
        layer.setAttribute("aria-modal", "false");
        layer.removeAttribute("tabIndex");
      }
    }
  }]);
}();
export { FiltersLayer as default };